import React from 'react';
import { StatCard } from '@dopomogai/ui'; // Assuming StatCard is exported from the UI library

type Props = {
  totalInvested: number;
  currentValue: number;
};

export function PortfolioSummaryHeader({ totalInvested, currentValue }: Props) {
  const totalReturn = currentValue - totalInvested;
  const returnPercentage = totalInvested > 0 ? (totalReturn / totalInvested) * 100 : 0;
  
  const getReturnColor = () => {
    if (totalReturn > 0) return 'text-emerald-600';
    if (totalReturn < 0) return 'text-rose-600';
    return 'text-slate-600';
  };

  return (
    <section className="grid gap-4 md:grid-cols-3">
      <StatCard
        title="Total Invested"
        value={`${totalInvested.toLocaleString()} cr`}
        description="The total amount of credits you have invested."
        icon="DollarSign"
      />
      <StatCard
        title="Portfolio Value"
        value={`${currentValue.toLocaleString()} cr`}
        description="The estimated current value of all your holdings."
        icon="TrendingUp"
      />
      <StatCard
        title="Total Return"
        value={`${totalReturn.toLocaleString()} cr`}
        description={`${returnPercentage.toFixed(2)}%`}
        icon="BarChart2"
      />
    </section>
  );
}